import { render, staticRenderFns } from "./DetalhesLancamentoCaixaDialog.vue?vue&type=template&id=970b7f38&"
import script from "./DetalhesLancamentoCaixaDialog.vue?vue&type=script&lang=js&"
export * from "./DetalhesLancamentoCaixaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports